var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-message-page',{attrs:{"title":"Questionario già compilato","message":"Non è possibile apportare ulteriori modifiche."}})}
var staticRenderFns = []

export { render, staticRenderFns }